import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SSOLandingPageLoginComponent } from './components/login/login.component';
import { SSOLandingPageErrorComponent } from './components/error/error.component';

const routes: Routes = [
  { path: '', component: SSOLandingPageLoginComponent },
  { path: 'welcome', component: SSOLandingPageLoginComponent },
  { path: 'error', component: SSOLandingPageErrorComponent },
];

export const routedComponents: any[] = [
  SSOLandingPageLoginComponent,
  SSOLandingPageErrorComponent,
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SSOLandingPageRoutingModule { }
